/* global axios */
// Per-account Wasapi module switches. Loaded once per session and cached in a module-level ref so
// every consumer (sidebar, pages) shares the same state. Everything defaults to enabled, so the UI
// never hides a feature because the request has not landed yet.
import { ref } from 'vue';

const DEFAULTS = {
  crm: true,
  appointments: true,
  internal_chat: true,
  scheduler: true,
  flows: true,
  campaigns: true,
  projects: true,
  templates: true,
};

const modules = ref({ ...DEFAULTS });
let loaded = false;
let inFlight = null;

const accountPath = () => {
  const match = window.location.pathname.match(/accounts\/(\d+)/);
  return match ? `/api/v1/accounts/${match[1]}/wasapi/modules` : null;
};

export const loadWasapiModules = async () => {
  if (loaded || inFlight) return inFlight;
  const url = accountPath();
  if (!url) return null;
  inFlight = axios
    .get(url)
    .then(({ data }) => {
      modules.value = { ...DEFAULTS, ...(data.payload || {}) };
      loaded = true;
    })
    .catch(() => {})
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
};

export const resetWasapiModules = () => {
  loaded = false;
  modules.value = { ...DEFAULTS };
};

export const useWasapiModules = () => {
  loadWasapiModules();
  return { modules, isEnabled: key => modules.value[key] !== false };
};
